class RespinService {
	#started = false;
	#totalWin = 0;

	get started() {
		return this.#started;
	}

	get totalWin() {
		return this.#totalWin;
	}

	start() {
		this.#totalWin = 0;
		this.#started = true;
	}

	stop() {
		this.#started = false;
	}

	addTotalWin(value) {
		this.#totalWin += value;
	}
}

export const respinService = new RespinService();
